import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './env';

export const STORAGE_CONFIG = {
  PRODUCT_BUCKET: 'product-images',
  STATIC_BUCKET: 'static-images',
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/webp', 'image/gif']
};

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Añadimos la función getPublicImageUrl con soporte dual
export const getPublicImageUrl = (name: string, isStatic: boolean = false): string => {
  if (!name) return '/images/placeholder-product.jpg';
  // Si ya es una ruta absoluta o local del repositorio
  if (name.startsWith('/') || name.startsWith('http://') || name.startsWith('https://')) {
    return name;
  }
  const bucket = isStatic ? STORAGE_CONFIG.STATIC_BUCKET : STORAGE_CONFIG.PRODUCT_BUCKET;
  const { data: { publicUrl } } = supabase.storage
    .from(bucket)
    .getPublicUrl(name);
  return publicUrl;
};

export const getProductImageUrl = async (productId: string, imageUrl?: string | null): Promise<string> => {
  // Si no hay URL, intentar encontrar la imagen en el bucket del producto
  if (!imageUrl) {
    try {
      const { data: files } = await supabase.storage
        .from(STORAGE_CONFIG.PRODUCT_BUCKET)
        .list(productId);

      if (files && files.length > 0) {
        const { data: { publicUrl } } = supabase.storage
          .from(STORAGE_CONFIG.PRODUCT_BUCKET)
          .getPublicUrl(`${productId}/${files[0].name}`);
        return publicUrl;
      }
    } catch (error) {
      console.error('Error accessing storage:', error);
    }
    return '/images/placeholder-product.jpg';
  }

  // Si ya es una URL local del repositorio
  if (imageUrl.startsWith('/')) {
    return imageUrl;
  }

  // Si la URL ya es una URL completa (Supabase Storage o CDN externa)
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }

  // Si es una ruta relativa al bucket de Supabase
  try {
    const { data: { publicUrl } } = supabase.storage
      .from(STORAGE_CONFIG.PRODUCT_BUCKET)
      .getPublicUrl(imageUrl);
    return publicUrl;
  } catch {
    return '/images/placeholder-product.jpg';
  }
};

// Función auxiliar para verificar si una URL es accesible
export const verifyImageAccess = async (url: string): Promise<boolean> => {
  try {
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  } catch {
    return false;
  }
};




